import { Dispatch, SetStateAction } from 'react'
import { SSM_PARAMETER_NAMES } from '../../constants/ssm'
import {
  SCORECARD_TARGETS,
  SCORECARD_WEIGHTS,
} from '../../constants/technician-scorecard'
import { fetchData } from '../fetch'

function getAwsSsmParameter(parameterName: string) {
  const endpoint = `${process.env.REACT_APP_ORIGIN}/aws-ssm-parameter?parameterName=${encodeURIComponent(parameterName)}`

  return {
    url: endpoint,
    method: 'GET',
  }
}

async function getAndSetScorecardWeightsAndTargets(
  setWeights: Dispatch<
    SetStateAction<Record<keyof typeof SCORECARD_WEIGHTS, number>>
  >,
  setTargets: Dispatch<
    SetStateAction<Record<keyof typeof SCORECARD_TARGETS, number>>
  >,
): Promise<void> {
  const [weightsString, targetsString] = await Promise.all([
    fetchData<string>(
      getAwsSsmParameter(SSM_PARAMETER_NAMES.TECHNICIAN_SCORECARD_WEIGHTS),
    ),
    fetchData<string>(
      getAwsSsmParameter(SSM_PARAMETER_NAMES.TECHNICIAN_SCORECARD_TARGETS),
    ),
  ])

  if (weightsString) {
    setWeights(JSON.parse(weightsString))
  }
  if (targetsString) {
    setTargets(JSON.parse(targetsString))
  }
}

export default getAndSetScorecardWeightsAndTargets
